import { TypeExam } from "app/constants/types/exam.types";

export const headExam = {
  upcomingExam:{
    title: 'Upcoming Exam',
    subtitle: '📣 Stay Informed & Never Miss an Exam'
  }
}

